<div class="l-panel">
    <div class="panel-title">
      <div class="sub-title">
        <span class="step-number">{{stepNumber}}</span>
        <p>{{'select.horse' | translate}}</p>
      </div>
      @if ((showAssociates && isCP) || isSpot) {
      <div class="options-select">
        @if(showAssociates && isCP) {
            <button
                class="btn btn-secondary"
                [class.selected]="isBase"
                (click)="toggleSelectionType('base')"
                >
                {{'selection.base' | translate}}
            </button>
            <button
                class="btn btn-secondary"
                [class.selected]="isAssociates"
                (click)="toggleSelectionType('associates')"
                >
                {{'selection.associates' | translate}}
            </button>
        }
        @if (isSpot) {
            <button
                class="btn btn-secondary"
                (click)="addXToBaseSelections()"
                [disabled]="baseSelectees.length >= baseHorseCount">
                &#88;
            </button>
        }
        </div>
        }
        <a class="btn btn-link" (click)="toggleDetails()">
            <img src="images/svg/list-ol.svg" alt="">
            {{ (voirDetails ? 'horse.details.hide' : 'horse.details.show') | translate }}
        </a>
    </div>
    <ng-content />
    @if (!voirDetails) {
    <div class="l-panel-ctn">
        @for (horse of horses; track horse.numero; ; let j = $index) {
        <button
            matRipple
            [matRippleCentered]="rippleOptions.centered"
            [matRippleDisabled]="rippleOptions.disabled"
            [matRippleUnbounded]="rippleOptions.unbounded"
            [matRippleRadius]="rippleOptions.radius"
            [matRippleColor]="rippleOptions.color"
            class="btn l-panel-item" [class.selected]="horse.selectionne || horse.associe" [class.favori]="horse.favori"
            (click)="selectPartant(isBase ? !horse.selectionne : !horse.associe, j, isAssociates)"
            [disabled]="isBase ? disablePartantSelection(horse) : isAssociates ? disableAssoSelection(horse) : false">
            {{ horse.numero }}
            <span>{{ horse.oldcotes }}</span>
        </button>
    }
    </div>
    }
    @if (voirDetails) {
    <div class="l-panel-ctn horses">
        <table>
            <thead>
                <tr>
                    <th >#</th>
                    <th>{{'horse.joker' | translate}}</th>
                    <th>{{'horse.last_performances' | translate}}</th>
                    <th>{{'age' | translate}}</th>
                    <th>{{'sex' | translate}}</th>
                    <th>{{'horse.rp' | translate}}</th>
                    @if (false) {
                        <th rowspan="2">
                            {{'selection.all' | translate}}
                            @if (showAssociates) {
                                <div class="select-type" >
                                    <span class="base">{{'selection.base' | translate}}</span>
                                    <div class="select-associates">
                                        <span class="associates">{{'selection.associates' | translate}}</span>
                                        <!-- <button type="button" class="icon-button" (click)="addXToBaseSelections()" [disabled]="baseSelectees.length >= maxHorseCount">
                                        X
                                        </button> -->
                                    </div>
                                </div>
                            }
                            @if (isSpot) {
                                <button type="button" class="icon-button" (click)="addXToBaseSelections()" [disabled]="baseSelectees.length >= maxHorseCount">
                                    X
                                </button>
                            }
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (horse of horses; track horse.numero; let k = $index) {
                    <tr class="block-horse">
                                <td >{{ horse.numero }}</td>
                                <td >
                                    <div class="cav">
                                        <strong>{{ horse.nom_partant }}</strong>
                                        {{ horse.jocker }}
                                    </div>
                                </td>
                                <td >{{ horse.performance }}</td>
                                <td >{{ horse.yearEarning }}</td>
                                <td >{{ horse.sexe }}</td>
                                <td >
                                    <strong>{{ horse.oldcotes }}</strong>
                                </td>
                                @if (false) {
                                <td >
                                    <div class="form-group form-check">
                                        <input type="checkbox" id="partantCheck{{k}}" [(ngModel)]="horse.selectionne" (ngModelChange)="selectPartant($event, k, false)"
                                        [disabled]="disablePartantSelection(horse)" />
                                        @if (showAssociates) {
                                            <input type="checkbox" id="associeCheck{{k}}" [(ngModel)]="horse.associe" (ngModelChange)="selectPartant($event, k, true)"
                                            [disabled]="disableAssoSelection(horse)" />
                                        }
                                    </div>
                                </td>
                                }
                                <!--  <td style="width: 12%;">
                                    <button (click)="toggleSelection(horse)"
                                        [class.selected]="horse.selectionne">✔</button>
                                </td> -->
                    </tr>
                }
            </tbody>
        </table>
    </div>
    }
</div>
